import React, {FC} from 'react';
import {FilterCard} from '../../../../atoms/FilterCard/FilterCard';
import {GenericFilterItemGroup} from '../../FilterContent/Shared/GenericFilteredItems/types';
import {FilterFlyoutSearch} from '../Shared/FilterFlyoutSearch';
interface Props {
  activeIds: Array<string>;
  hide: VoidFunction;
  isOpen: boolean;
  itemGroups: Array<GenericFilterItemGroup>;
  label: string;
  onItemClick: (itemId: string, itemSlug?: string) => void;
  open: VoidFunction;
  submit: VoidFunction;
  enableFlyoutFilter: boolean;
}

export const FilterFlyoutGroupedAttributes: FC<Props> = ({
  activeIds,
  itemGroups,
  hide,
  isOpen,
  label,
  onItemClick,
  open,
  submit,
  enableFlyoutFilter,
}) => {
  return (
    <div data-testid="filterFlyoutSectionGroupedAttributes">
      <FilterCard
        count={activeIds.length ?? undefined}
        title={label}
        onClick={open}
        disableHorizontalPadding={enableFlyoutFilter}
      />

      <FilterFlyoutSearch
        hide={hide}
        submit={submit}
        isOpen={isOpen}
        label={label}
        activeIds={activeIds}
        itemGroups={itemGroups}
        onItemClick={onItemClick}
      />
    </div>
  );
};
